module.exports = __webpack_public_path__ + "user/img/eval360.de7bb1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/eval360.png
// module id = tycR
// module chunks = 1